import React, { useState, useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import axios from 'axios';
import { _ } from '_locales';
import endpoints from '_apis';
import { connect } from 'react-redux';
import Question from '../components/Question';
import Explanation from '../components/Explanation';

import {
  Image,
  PollRow,
  Description,
  OptionsContainer,
} from '../components';

import * as actions from '../../redux/actions';
import { Button } from '../../components';
import eventTracker from '../../../../helpers/eventTracker';
import events from '../../events';
import { cts_secure } from '../../../../app/cts';

const Carousel = styled.div`
  display: flex;
  justify-content: center;
`;

const HorizontalBullet = styled.div`
    height: 10px;
    margin: 10px 3px;
    background-color: ${({ isCurrentSlide }) => (isCurrentSlide ? '#76CBC4' : 'rgba(0, 0, 0, 0.06)')} ;
    width: ${({ isCurrentSlide }) => (isCurrentSlide ? '20px' : '10px')} ;
    border-radius: 10px;
`;

const Quiz = ({
  wwtkItems,
  uuid,
  projectId,
  districtId,
  zones,
  setWwtkDoneItem,
  selectedLang,
  doneActivities,
  colors,
  ...props
}) => {
  const [buttonActive, setButtonActive] = useState(true);
  const [canContinue, setCanContinue] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const { main_color } = colors;
  const coachable = props;
  const {
    campaign_id,
    district_id,
    dispatch,
    coachable_id,
    done,
    oidx,
    screen,
    type,
    image_path,
    correct_answer_feedback: correctAnswerFeedback,
    wrong_answer_feedback: wrongAnswerFeedback,
    quiz_correct_answer: quizCorrectAnswer,
    poll_quiz_question: pollQuizQuestion,
    ...options
  } = coachable;
  const [question, setQuestion] = useState(pollQuizQuestion);
  const [description, setDescription] = useState('');
  const [explanation, setExplanation] = useState('');
  const imgRef = useRef();

  useEffect(() => {
    setButtonActive(true);
    setCanContinue(false);
    setCorrectAnswer(null);
    setSelectedOption(null);
    setExplanation(null);
    setDescription(null);
    setQuestion(pollQuizQuestion);
  }, [coachable_id, selectedLang, campaign_id]);

  /**
   * Handler for options
   * @param {*} item
   */
  const optionPressHandler = async (item) => {
    const theOption = item.split('_')[item.split('_').length - 1];
    const didAnswerCorrect = parseInt(quizCorrectAnswer, 10) === parseInt(theOption, 10);
    feedbackToServer(theOption);
    setSelectedOption(theOption);
    setCorrectAnswer(didAnswerCorrect);
    setDescription(
      (didAnswerCorrect) ? correctAnswerFeedback : wrongAnswerFeedback
    );
    setExplanation('Explanation');
    setCanContinue(true);
    eventTracker(
      events.HOME_SCREEN_WWTK_QUIZ_OPTION_SELECT,
      {
        selected_option: theOption,
        campaign_id,
        coachable_id,
        correct: didAnswerCorrect
      }
    );
  };

  /**
   * Feedback to server
   */
  const feedbackToServer = async (theOption) => {
    try {
      const payload = {
        uuid,
        project_id: projectId,
        district_id: districtId,
        campaign_id,
        coachable_id,
        user_choice: theOption,
        zone: zones,
        source: 'webapp'
      };
      await cts_secure('post', endpoints.wwtkFeedback('quiz'), payload);
    } catch (e) {
      // TODO: Log error
    }
  };

  /**
   * Current Quiz data
   */
  const currentActivity = wwtkItems
    .find((activity) => activity.coachable_id === coachable_id
      && activity.campaign_id === campaign_id);

  /**
    * Index of the current Quiz
    */
  const index = wwtkItems
    .findIndex(({ coachable_id, campaign_id }) => coachable_id === currentActivity.coachable_id
      && campaign_id === currentActivity.campaign_id);

  /**
   * Array of string, each element is equal to 'otherSlide'
   * except for the element with index of current Slide which has value of 'currentSlide'
   */
  const bullets = Array(wwtkItems.length).fill('otherSlide');
  bullets[index] = 'currentSlide';

  return (

    <OptionsContainer key={index} imageRef={imgRef} style={{ height: '100%', width: 'auto' }}>
      {
        image_path
          ? (
            <Image
              ref={imgRef}
              link={endpoints.getCampaignImage(image_path)}
            />
          ) : null
      }
      <fieldset style={{ border: 'none' }}>
        <Question content={question} />
        {
          Object.keys(options).length
            ? Object.keys(options).map((option, i) => (
              (options[option])
                ? (
                  <PollRow
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    name={coachable_id}
                    title={options[option]}
                    pressHandler={() => optionPressHandler(option, coachable_id)}
                    neutral={!selectedOption && !(parseInt(option.split('_')[option.split('_').length - 1], 10) === parseInt(selectedOption, 10))}
                    answer={parseInt(option.split('_')[option.split('_').length - 1], 10) === parseInt(selectedOption, 10)}
                    isCorrect={correctAnswer}
                    correctOption={quizCorrectAnswer}
                    optionValue={option}
                    disabled={!!selectedOption}
                  />
                ) : null
            )) : null
        }
      </fieldset>

      <div>
        <Explanation
          content={explanation}
        />
      </div>
      <div>
        <Description
          content={description}
        />
      </div>
      <div>
        {
          canContinue
            ? (
              <Button
                mainColor={main_color || false}
                aria-label={doneActivities.length === wwtkItems.length - 1
                  ? 'Finish we wanted to know questions'
                  : 'Ask me another we wanted to know question'}
                margin="20px 10px 15px auto"
                onClick={() => {
                  if (buttonActive) {
                    setButtonActive(false);
                    const doneItem = { coachableId: coachable_id, campaignId: campaign_id };
                    setWwtkDoneItem(JSON.stringify(doneItem));
                  }
                }}
              >
                {doneActivities.length === wwtkItems.length - 1 ? _('resources.finish') : _('resources.ask_me_another')}
              </Button>
            ) : null
        }
        <Carousel>
          {bullets.map((bullet) => <HorizontalBullet isCurrentSlide={bullet === 'currentSlide'} />)}
        </Carousel>
      </div>
    </OptionsContainer>
  );
};

export default connect(
  (store) => ({
    wwtkItems: store.education.wwtk_items || null,
    doneActivities: store.wwtk.doneActivities || [],
    uuid: store.plugin.uuid,
    projectId: store.plugin.projectId,
    districtId: store.config.districtId,
    zones: store.zone.zoneStr,
    selectedLang: store.config.selectedLang,
    colors: store.config.templateColour ? JSON.parse(store.config.templateColour) : {},
  }),
  (dispatch) => ({
    setWwtkDoneItem: (id) => dispatch(actions.setWwtkDoneItem(id))
  })
)(Quiz);
